exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-52533aca] {\r\n    padding: 20px;\n}\n.filter-item[data-v-52533aca] {\r\n    margin-left: 10px;\r\n    margin-bottom: 10px;\n}\n.table-fixed[data-v-52533aca] .el-table__body-wrapper{\r\n    height: calc(100%-44) !important;\n}\r\n", ""]);

// exports
